import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASBonusPickOptions, ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {PearlHarbor} from "./PearlHarbor";
import {PearlHarborGameMode} from "./server/PearlHarborGameMode";
import {PearlHarborSoundManager} from "./sound/PearlHarborSoundManager";
import {PearlHarborSoundConfig} from "./sound/PearlHarborSoundConfig";
import {PearlHarborGameData} from "./server/PearlHarborData";
import {PearlHarborHelper} from "./utils/PearlHarborHelper";

export class PearlHarborPromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Pearl Harbor",
            hasActionSpin: true,
            mainGame: {
                header: () => PearlHarbor.apiPlugin.translations.translate("xBET"),
                options: [
                    {name: "NORMAL", id: 0, image: "NORMAL.png"},
                    {name: "BOOSTED_BET", id: 1, image: "BOOSTED_BET.png"},
                    {name: "BOOSTED_BET_2", id: 1, image: "BOOSTED_BET_2.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            graphics: {backgroundTextureName: "introBg"},
            getParsedData: (response: any, bet: number, prevResponse: any): ASWinData => {

                const win = this.getWin(response, bet, prevResponse);
                const parsedData: ASWinData = {
                    totalWin: this.getTotalWin(response, bet),
                    totalSpinWinnings: win,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response, win),
                    winType: response.mode.indexOf("FREESPIN") > -1 ? WINTYPE.MULTIPLIER : WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank
                }
                // parsedData.isBigWin = this.isBigWin(response.totalSpinWinnings, response.playedBetValue, response.mode);
                return parsedData;
            }
        };
    }

    private isBigWin(response: any, multiplier: number = 0): boolean {
        let playedBetValue = response.playedBetValue;
        let win = response.mode.indexOf("FREESPIN") > -1 ? multiplier * playedBetValue : response.accumulatedRoundWin;
        if (response.wasFeatureBuy) {
            playedBetValue = PearlHarborHelper.getBuyFeaturePrice()
            let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);
        return winRatio >= 15;
    }

    private getMultiplier(response: PearlHarborGameData): number {
        let multiplier: number = 0;
        if (response.mode === PearlHarborGameMode.FREESPIN) {
            multiplier = response.dogfight?.totalMult || multiplier;
        } else if (response.mode === PearlHarborGameMode.SUPER_FREESPIN) {
            multiplier = response.finalWave?.totalMult || multiplier;
        }
        return multiplier;
    }

    private getTotalWin(response: PearlHarborGameData, bet: number): number {
        let fsWin: number = 0,
            isLastFS: boolean = response.nextMode === PearlHarborGameMode.NORMAL;
        if (response.mode === PearlHarborGameMode.FREESPIN) {
            fsWin = (response.dogfight?.totalMult || 0) * bet;
        } else if (response.mode === PearlHarborGameMode.SUPER_FREESPIN) {
            fsWin = (response.finalWave?.totalMult || 0) * bet;
        }
        fsWin = isLastFS ? 0 : fsWin;
        return response.accumulatedRoundWin + fsWin;
    }

    private getWin(response: PearlHarborGameData, bet: number, prevData: PearlHarborGameData): number {
        let multiplier: number = this.getMultiplier(response);
        if (multiplier && prevData) {
            const prevMultiplier: number = this.getMultiplier(prevData);
            multiplier -= prevMultiplier;
        }
        return multiplier;
    }

    private isFreeSpinTriggered(data: PearlHarborGameData): boolean {
        return data.freespinTriggeredThisSpin && data.nextMode !== PearlHarborGameMode.NORMAL && !data.brokeBank;
    }


    private getFeatureName(response: any): string {
        if (response.nextMode == PearlHarborGameMode.FREESPIN || response.mode == PearlHarborGameMode.FREESPIN) {
            return "DOGFIGHT"
        }
        if (response.nextMode == PearlHarborGameMode.SUPER_FREESPIN || response.mode == PearlHarborGameMode.SUPER_FREESPIN) {
            return "TORA! TORA! TORA!"
        }
        return "";
    }

    private isRoundComplete(response: PearlHarborGameData): boolean {
        return [PearlHarborGameMode.FREESPIN, PearlHarborGameMode.SUPER_FREESPIN, PearlHarborGameMode.NORMAL].indexOf(response.nextMode) > -1;
    }

    private isBonusEnd(response: PearlHarborGameData): boolean {
        return response.nextMode === PearlHarborGameMode.NORMAL && (response.mode.indexOf("NORMAL") === -1);
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            PearlHarborSoundManager.playSoundEffect(PearlHarborSoundConfig.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            PearlHarborSoundManager.playSoundEffect(PearlHarborSoundConfig.AS_WIN_BIG);
        }
    }

    onPlayBonusInGame(data: any): void {
        PearlHarbor.model.onGame(data);
        PearlHarbor.keypadPlugin.setWin(PearlHarbor.model.gameData.accumulatedRoundWin, true, PearlHarborHelper.isWinBelowStake())
        PearlHarbor.keypadPlugin.hide();
        PearlHarbor.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        PearlHarbor.allReelsView.reInit(PearlHarbor.model.allSymbolsData);

        PearlHarbor.fsIntroView.show((index: number) => {
            PearlHarbor.cocpitBoard.show(PearlHarbor.model.isRestore);
            PearlHarbor.setMode(PearlHarbor.model.data.nextMode);
            PearlHarbor.mainGameZoomContainer.hideOnFSIntro();
            PearlHarbor.activeSymbolsBackground.hideOnFSIntro()
            PearlHarbor.keypadPlugin.setZeroBetSpinCounter(PearlHarbor.model.data.freespinsLeft || 0);
            PearlHarbor.gameFlowController.start();
            PearlHarbor.keypadPlugin.show()
        }, PearlHarbor.apiPlugin.isReplay);
    }


}